import type { IssuePerson } from "../../types/issue-triage";

/**
 * The signed-in user as the server will stamp them: the owner-config name when
 * they are one of the issue owners, otherwise their login email — never
 * users.displayName (editable by the user). Used only for OPTIMISTIC cache
 * updates and unsaved-edit attribution; stored values come from the server.
 */
export function signedInAsIssuePerson(
  user: { userId?: string; email?: string } | null | undefined,
  owners: readonly IssuePerson[] | undefined
): IssuePerson | undefined {
  if (!user?.userId) return undefined;
  const owner = owners?.find((o) => o.uid === user.userId);
  return { uid: user.userId, name: owner?.name ?? (user.email || user.userId) };
}
